import React, { Component } from 'react';
import { Link, Navigate } from 'react-router-dom';
import Top from './Top';
import Bottom from './Bottom';
import Xqhz1 from './img/szjs1.png';
import Xqhz2 from './img/szjs2.png';
import Jylw1 from './img/jylw1.png';
import Jylw2 from './img/jylw2.png';
import hzImg from './img/hz.png';
import sz1Img from './img/sz1.jpg';
import './PremiumConnect.css';
import './PageLayout.css';
import './ProjectDetail.css';

// 师资建设项目数据
const facultyData = [
    {
        id: 1,
        title: "教研论文",
        image: Xqhz1,
        description: "教师团队在嵌入式系统设计领域发表了多篇高质量教研论文，涵盖了嵌入式系统架构设计、实时操作系统优化、物联网应用开发等前沿技术方向。这些研究成果不仅提升了课程的学术水平，也为学生提供了最新的技术知识和实践经验。",
        additionalImages: [Jylw1, Jylw2]
    },
    {
        id: 2,
        title: "教师团队",
        image: hzImg,
        description: "教师团队在教学和科研方面取得了显著成就，获得了多项荣誉和奖励。包括教学成果奖、优秀教师称号、科研项目资助等。这些荣誉体现了教师团队在嵌入式系统教育领域的专业水平和影响力，也为学生提供了高质量的教学保障。此外，教师团队还积极参与智慧课程建设要领与分级认定标准的教师培养讲座，不断提升教学水平和专业能力，为学生提供更优质的教育。",
        additionalImages: [Xqhz2, sz1Img]
    }
];

class Connect extends Component {
    componentDidMount() {
        // 如果是详情页面，滚动到顶部
        if (this.props.id) {
            document.documentElement.scrollTop = document.body.scrollTop = 0;
        }
    }

    render() {
        // 检查是否有ID参数，如果有则显示详情页面
        if (this.props.id) {
            const facultyId = parseInt(this.props.id);
            const faculty = facultyData.find(item => item.id === facultyId);
            
            // 如果找不到对应的项目，重定向到师资建设页面
            if (!faculty) {
                return <Navigate to="/faculty" />;
            }
            
            return (
                <div>
                    <Top />
                    <div className="page-container">
                        <div className="page-header">
                            <h1 className="page-title">{faculty.title}</h1>
                        </div>
                        <div className="project-detail-container faculty-detail">
                            <div className="project-detail-image">
                                <img src={faculty.image} alt={faculty.title} />
                            </div>
                            <div className="project-detail-content">
                                <p>{faculty.description}</p>
                                {/* 如果有额外图片，显示额外的图片 */}
                                {faculty.additionalImages && (
                                    <div className="additional-images-container">
                                        <div className="additional-images-grid">
                                            {faculty.additionalImages.map((img, index) => (
                                                <div key={index} className="additional-image-item">
                                                    <img src={img} alt={`教师团队图片${index + 1}`} />
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <Bottom />
                </div>
            );
        }
        
        // 否则显示列表页面
        return (
            <div className="premium-connect" id="d">
                <div className="premium-connect-container">
                    <Link to="/faculty-detail/1" className="premium-connect-card">
                        <img className="premium-connect-image" src={Xqhz1} alt="教研论文" />
                        <div className="premium-connect-content">
                            <h3 className="premium-connect-title">教研论文</h3>
                        </div>
                    </Link>
                    <Link to="/faculty-detail/2" className="premium-connect-card">
                        <img className="premium-connect-image" src={hzImg} alt="教师团队" />
                        <div className="premium-connect-content">
                            <h3 className="premium-connect-title">教师团队</h3>
                        </div>
                    </Link>
                </div>
            </div>
        );
    }
}
export default Connect;